/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
// import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import env from "config/env";
import { useParams } from "react-router-dom";
import Loader from "examples/Loader";
import { useAgencyById } from "queries/agency";

function AgencyConnection() {
    const { agency_id } = useParams();

    const searchParams = new URLSearchParams(document.location.search);
    const sessionkey = searchParams.get("sessionkey");

    const { data: agency = {}, isLoading } = useAgencyById(agency_id);

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <iframe
                        src={`https://marketplace.gohighlevel.com/oauth/chooselocation?response_type=code&redirect_uri=${env.GHL.REDIRECT.AGENCY}&client_id=${env.GHL.CLIENT_ID}&scope=${env.GHL.ACCOUNT_SCOPE}&state=${agency._id}&sessionKey=${sessionkey}`}
                        style={{ height: "100vh", width: "100%" }}
                    ></iframe>
                </>
            )}
        </>
    );
}

export default AgencyConnection;
